import { SORT_ARGS } from "../candidates-const";
import {SortingModelAbstract} from "@/models/SortingModelAbstract";

export default class CandidatesSortModel extends SortingModelAbstract {
  constructor(query) {
    super(SORT_ARGS);

    this.by = []
    this.desc = []
    this.ordering = null
    this._apiAttributes = {
      inQueue: SORT_ARGS.IN_QUEUE,
      failed: SORT_ARGS.FAILED,
      onHold: SORT_ARGS.ON_HOLD,
      candidateName: SORT_ARGS.NAME,
      candidateBirthday: SORT_ARGS.BIRTHDAY,
      status: SORT_ARGS.STATUS,
      accountUsername: SORT_ARGS.CBR_ACCOUNT,
      productName: SORT_ARGS.PRODUCT_NAME,
      reserved: SORT_ARGS.RESERVED_INFO,
      color: SORT_ARGS.COLOR,
    }
    this._customSorting = {
      reserved: (ordering) => this.setReservedSorting(ordering)
    }
    this._orderingFields = {
      [SORT_ARGS.NAME]: 'candidateName',
      [SORT_ARGS.BIRTHDAY]: 'candidateBirthday',
      [SORT_ARGS.IN_QUEUE]: 'inQueue',
      [SORT_ARGS.FAILED]: 'failed',
      [SORT_ARGS.ON_HOLD]: 'onHold',
      [SORT_ARGS.STATUS]: 'status',
      [SORT_ARGS.CBR_ACCOUNT]: 'accountUsername',
      [SORT_ARGS.PRODUCT_NAME]: 'productName',
      [SORT_ARGS.RESERVED_INFO]: 'reserved',
      [SORT_ARGS.COLOR]: 'color'
    }
    this._initByQuery(query)
  }

  _getQueueApiData() {
    let index = this.by.findIndex(field => field === 'inQueue')
    if(index < 0) return
    return this._transformQueryBoolean(this.desc[index])
  }

  _getFailedApiData() {
    let index = this.by.findIndex(field => field === 'failed')
    if(index < 0) return
    return this._transformQueryBoolean(this.desc[index])
  }

  _getOnHoldApiData() {
    let index = this.by.findIndex(field => field === 'onHold')
    if(index < 0) return
    return this._transformQueryBoolean(this.desc[index])
  }

  _getOrderingApiData() {
    let index = this.by.findIndex(field => field === 'ordering')
    if(index < 0) return
    return this._transformQueryBoolean(this.desc[index])
  }

  _setOrdering(data) {
    let ordering = []
    this.by.forEach(field => {
      if(!( field in this._customSorting)) { // if false - set ordering
        // this._removeSelectedOrdering(this._apiAttributes[field], data)
        let index = this.by.findIndex(selectedField => selectedField === field)
        ordering.push(this._convertBooleanToOrderingFormat(this.desc[index], this._apiAttributes[field]))
      }
      else if(field in this._customSorting) this._customSorting[field](ordering)
    })
    data[SORT_ARGS.ORDERING] = ordering
  }

  _removeSelectedOrdering(field, data) {
    if(SORT_ARGS.ORDERING in data && (data[SORT_ARGS.ORDERING] !== field || data[SORT_ARGS.ORDERING] !== `-${field}`)) {
      let fieldName = SORT_ARGS.ORDERING.replace('-', '')
      let fieldNameToRemove = this._orderingFields[fieldName]
      let index = this.by[fieldNameToRemove]
      this.by.splice(index, 1)
      this.desc.splice(index, 1)
    }
  }

  _convertBooleanToOrderingFormat(val, field) {
    if(!val) return `-${field}`
    if(val) return field
    return
  }

  _convertBooleanToMultiOrderingFormat(val, field) {
    if (!val) {
      return field.split(',').map(item => `-${item}`).join(',')
    }
    if (val) {
      return field.split(',').map(item => `${item}`).join(',')
    }
    return
  }

  setReservedSorting(ordering) {
    let index = this.by.findIndex(selectedField => selectedField === 'reserved')
    ordering.push(this._convertBooleanToMultiOrderingFormat(this.desc[index], `${SORT_ARGS.EXAM_LOCATION},${SORT_ARGS.RESERVED_INFO}`))
  }

}
